<template>
<div class="about-area">
   <div class="container">
            <!-- Trending Tittle -->
            <div class="row">
               <div class="col-lg-12">
                     <div class="trending-tittle">
                     </div>
               </div>
            </div>
            <div class="row">
               <div class="col-lg-8">
                     <!-- Trending Tittle -->
                           <div class="about-right mb-90">
                                 <div class="section-tittle mb-30 pt-30">
                                    <h3 style="text-align: center;">THÔNG BÁO VỀ VIỆC ĐẤU GIÁ TÀI SẢN</h3>
                                 </div>
                                 <div class="about-prea" style="text-align: justify;">
                                    <p class="about-pera1">Công ty Đấu giá Hợp danh Số 5 – Quốc gia chuẩn bị đưa ra đấu giá tài sản bằng hình thức trực tuyến trên Trang thông tin điện tử đấu giá trực tuyến (địa chỉ: <a href="https://daugiaso5.vn/">https://daugiaso5.vn/</a>) với các nội dung như sau:</p>
                                    <p class="about-pera1">* Tài sản đấu giá: Quyền sử dụng đất, nhà ở và tài sản gắn liền với đất theo Giấy chứng nhận Quyền sử dụng đất quyền sở hữu nhà ở và tài sản khác gắn liền với đất số CP 333690; số vào sổ cấp GCN: CS 53580 do Sở Tài nguyên và Môi trường thành phố Hà Nội, cấp ngày 24/10/2018. Thông tin chi tiết về Tài sản sẽ được phát hành kèm theo Hồ sơ mời tham gia đấu giá.</p>
                                    <p class="about-pera1">Tài sản theo mô tả của người có tài sản như sau: Tài sản là căn hộ tập thể tại tầng 4 và tầng 5 thuộc khu Tập thể xây dựng cho cán bộ quận Hoàn Kiếm, số 26 phố Lương Ngọc Quyến, phường Hàng Buồm, quận Hoàn Kiếm, thành phố Hà Nội. Diện tích sàn: 25,6 m2, diện tích sử dụng khoảng hơn 50 m2 (Căn hộ thoáng mát, 04 mặt tiền, tầng 4 có 01 phòng khách, bếp và nhà vệ sinh; tầng 5 có thể làm 2 phòng ngủ). Khu nhà nằm ngay trong phố đi bộ, cách Hồ Gươm khoảng 500 m, liền kề các phố Tạ Hiện và Đào Duy Từ, rất thuận tiện để sinh sống hoặc kinh doanh homestay.</p>
                                    <p class="about-pera1">* Giá khởi điểm dự kiến: 2.200.000.000 đồng (Bằng chữ: Hai tỷ hai trăm triệu đồng).</p>
                                    <p class="about-pera1">* Bước giá: <strong>1.000.000 đồng</strong> (Bằng chữ: Một triệu đồng).</p>
                                    <p class="about-pera1">* Thời gian dự kiến tổ chức đấu giá: <strong>Tháng 7 năm 2020.</strong></p>
                                    <p class="about-pera1">* Cách thức đấu giá: <strong>đấu giá tài sản bằng hình thức trực tuyến</strong> trên Trang thông tin điện tử đấu giá trực tuyến (địa chỉ: <a href="https://daugiaso5.vn/">https://daugiaso5.vn/</a>)</p>
                                    <p class="about-pera1">* Chi tiết xin liên hệ: </p>
                                    <p class="about-pera1">- <i>Công ty Đấu giá Hợp danh Số 5 – Quốc gia; ĐT: 024.37.622.619.</i></p>
                                    <p class="about-pera1">- <i>Địa chỉ: Số 193 Hoàng Văn Thái, Khương Trung, Thanh Xuân, thành phố Hà Nội.</i></p>
                                 </div>
                           </div>
               </div>
               <div class="col-lg-4">
               </div>
            </div>
   </div>
</div>
</template>

<script>
import mixin from '@/mixins/mixin.js'
export default {
  name: 'Invates',
  mixins: [mixin],
  data () {
    return {
    }
  },
  methods: {
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Invates/2.vue